<div class="chatrooms-list">
<!--    <h1>Chat Rooms</h1>-->

    <div class="create-post">
        <div class="img">
            <img src="assets/img/item-4.png" alt="">
            <span>Create Post</span>
        </div>
        <div class="select">
            <select name="" id="">
                <option value="">Choose community</option>
                <option value="">option</option>
            </select>
        </div>

        <div class="input">
            <input placeholder="Title" type="text">
        </div>

        <label class="add-photo">
            <input type="file">
            <span class="material-icons">image</span>
            Add Photo or Video
        </label>

        <div class="btn">
            <button class="post">Post</button>
        </div>
    </div>

    <ul class="categories">
        <li><a class="active"><span class="material-icons">whatshot</span>Hot</a></li>
        <li><a><span class="material-icons">new_releases</span>New</a></li>
        <li><a><span class="material-icons">trending_up</span>Top</a></li>
        <li><a><span class="material-icons">new_releases</span>Best of the week</a></li>
    </ul>

    <div class="search">
        <input placeholder="Search" type="text">
        <span class="material-icons">search</span>
    </div>

    <div class="chatrooms-items">
        <div class="item">
            <div class="posted">
                <p>Posted by<span>u/alotasalad</span></p>
                <p>4 minutes ago</p>
            </div>

            <div class="info">
                <div class="left-wrap">
                    <div class="voting-container">
                        <button class="vote-up-btn active">
                            <span class="material-icons">forward</span>
                        </button>
                        <div class="vote-count">50k</div>
                        <button class="vote-down-btn">
                            <span class="material-icons">forward</span>
                        </button>
                    </div>
                </div>
                <div class="right-wrap">
                    <p>This is my friends loss but to make matters even worse he borrowed the money from his Nigerian
                        boss and yolod everything on fds otw up and down did I forget to mention that 4K in the the
                        account right now is also his bosses money 💰</p>

                    <img src="assets/img/jp-valeryunsplash.png" alt="">

                    <div class="post-menu">
                        <div class="menu">
                            <a href=""><span class="material-icons">chat_bubble</span>Comments</a>
                            <a href=""><span class="material-icons">share</span>Share</a>
                        </div>
                        <div class="dotes"><span class="material-icons">more_vert</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="item">
            <div class="posted">
                <p>Posted by<span>u/alotasalad</span></p>
                <p>4 minutes ago</p>
            </div>

            <div class="info">
                <div class="left-wrap">
                    <div class="voting-container">
                        <button class="vote-up-btn active">
                            <span class="material-icons">forward</span>
                        </button>
                        <div class="vote-count">50k</div>
                        <button class="vote-down-btn">
                            <span class="material-icons">forward</span>
                        </button>
                    </div>
                </div>
                <div class="right-wrap">
                    <p>This is my friends loss but to make matters even worse he borrowed the money from his Nigerian
                        boss and yolod everything on fds otw up and down did I forget to mention that 4K in the the
                        account right now is also his bosses money 💰</p>

                    <img src="assets/img/jp-valeryunsplash.png" alt="">

                    <div class="post-menu">
                        <div class="menu">
                            <a href=""><span class="material-icons">chat_bubble</span>Comments</a>
                            <a href=""><span class="material-icons">share</span>Share</a>
                        </div>
                        <div class="dotes"><span class="material-icons">more_vert</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="item">
            <div class="posted">
                <p>Posted by<span>u/alotasalad</span></p>
                <p>4 minutes ago</p>
            </div>

            <div class="info">
                <div class="left-wrap">
                    <div class="voting-container">
                        <button class="vote-up-btn active">
                            <span class="material-icons">forward</span>
                        </button>
                        <div class="vote-count">50k</div>
                        <button class="vote-down-btn">
                            <span class="material-icons">forward</span>
                        </button>
                    </div>
                </div>
                <div class="right-wrap">
                    <p>This is my friends loss but to make matters even worse he borrowed the money from his Nigerian
                        boss and yolod everything on fds otw up and down did I forget to mention that 4K in the the
                        account right now is also his bosses money 💰</p>

                    <img src="assets/img/jp-valeryunsplash.png" alt="">

                    <div class="post-menu">
                        <div class="menu">
                            <a href=""><span class="material-icons">chat_bubble</span>Comments</a>
                            <a href=""><span class="material-icons">share</span>Share</a>
                        </div>
                        <div class="dotes"><span class="material-icons">more_vert</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="item">
            <div class="posted">
                <p>Posted by<span>u/alotasalad</span></p>
                <p>4 minutes ago</p>
            </div>

            <div class="info">
                <div class="left-wrap">
                    <div class="voting-container">
                        <button class="vote-up-btn active">
                            <span class="material-icons">forward</span>
                        </button>
                        <div class="vote-count">50k</div>
                        <button class="vote-down-btn">
                            <span class="material-icons">forward</span>
                        </button>
                    </div>
                </div>
                <div class="right-wrap">
                    <p>This is my friends loss but to make matters even worse he borrowed the money from his Nigerian
                        boss and yolod everything on fds otw up and down did I forget to mention that 4K in the the
                        account right now is also his bosses money 💰</p>

                    <img src="assets/img/jp-valeryunsplash.png" alt="">

                    <div class="post-menu">
                        <div class="menu">
                            <a href=""><span class="material-icons">chat_bubble</span>Comments</a>
                            <a href=""><span class="material-icons">share</span>Share</a>
                        </div>
                        <div class="dotes"><span class="material-icons">more_vert</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
